import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ProductContext from '@/product/context/template/product/productContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import UserContext from '@/product/context/user/userContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import {
    initialFunction,
    validationFunction,
    editValue,
} from '@/product/components/species/dynamic/common/FieldFunction'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ReportContext from '@/product/context/report/reportContext'

const BulkListing = (props) => {
    const {
        bulkProjectAction,
        uploadXLSXFile,
        responseStatus: bulkUploadStatus,
        clearResponse: bulkUploadClear,
    } = useContext(ProductContext)
    const [isLoading, setIsLoading] = useState(false)
    const { resetDropZone, allCountries, allStates, allCities } =
        useContext(ProductCommonContext)
    const [reload, setReload] = useState(false)
    const [mapDataFields, setMapDataFields] = useState([])
    const dynamicContext = useContext(DynamicContext)
    const { project_dynamicfields } = dynamicContext
    const {
        getXLSXFile,
        responseStatus: responseStatusReport,
        clearResponse: clearResponseReport,
    } = useContext(ReportContext)

    const { allCategory, allLocations, allCondition, alldata_all_dropdown } =
        useContext(CustomCommonContext)

    const { getAllUsers, all_users } = useContext(UserContext)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        categoryTypeId: Yup.string(),
        subCategoryTypeId: Yup.string(),
        uploadFiles: Yup.array().required('Required!'),
    })
    const subStateOptions = (data) => {
        let valueDrop = allStates
            .filter(
                (state) =>
                    (formik.values.country
                        ? formik.values.country.indexOf(state.countryCode) !==
                          -1
                        : global.defaultCountry.indexOf(state.countryCode) !==
                          -1) &&
                    global.ignoreStates.indexOf(state.isoCode) === -1
            )
            .map((buscat) => {
                let busCategoryChanged = {}
                busCategoryChanged.show = buscat.name
                busCategoryChanged.value = buscat.isoCode
                return busCategoryChanged
            })
        return valueDrop
    }

    const subCityOptions = (data) => {
        console.log(formik.values, 'formikk')
        let valueDrop = allCities
            .filter((state) =>
                formik.values?.country && formik.values?.state
                    ? formik.values.country.indexOf(state.countryCode) !== -1 &&
                      formik.values.state.indexOf(state.stateCode) !== -1
                    : formik.values.state
                    ? global.defaultCountry.indexOf(state.countryCode) !== -1 &&
                      formik.values.state.indexOf(state.stateCode) !== -1
                    : false
            )
            .map((buscat) => {
                let busCategoryChanged = {}
                busCategoryChanged.show = buscat.name
                busCategoryChanged.value = buscat.name
                return busCategoryChanged
            })
        console.log(valueDrop, 'dropcity')
        return valueDrop
    }
    const subLevelOptions = (data) => {
        let valueDrop = []
        console.log(data, 'subselect')
        valueDrop = alldata_all_dropdown
            .filter((subcat) => {
                if (
                    formik.values[data.sub_field] &&
                    parseInt(subcat.level, 10) === parseInt(data.sub_level, 10)
                ) {
                    if (
                        parseInt(subcat.active, 10) === 1 ||
                        (formik.values[data.name] &&
                            formik.values[data.name] === subcat.id)
                    ) {
                        if (data.diff_value) {
                            let mainId = alldata_all_dropdown.filter(
                                (item) =>
                                    item.value === formik.values[data.sub_field]
                            )[0]
                            console.log(mainId, 'mainId')
                            return (
                                parseInt(subcat.level_id, 10) ===
                                parseInt(mainId?.id, 10)
                            )
                        } else {
                            return (
                                parseInt(formik.values[data.sub_field], 10) ===
                                parseInt(subcat.level_id, 10)
                            )
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            })
            .map((subcat) => {
                console.log(subcat, 'subb')
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.description
                subCategoryChanged.value = data.diff_value
                    ? subcat.value
                    : subcat.id
                return subCategoryChanged
            })
        if (valueDrop.length) {
            return valueDrop
        } else {
            return valueDrop
        }
    }
    // const mapDataFields = [
    //     {
    //         id: 1,
    //         isRequired: true,
    //         colId: 1,
    //         label: 'Template  Name',
    //         name: 'template_name',
    //         placeholder: 'Enter your Template Name',
    //         type: 'text',
    //     },
    //
    //     {
    //         id: 16,
    //         isRequired: false,
    //         colId: 14,
    //         name: 'location_type',
    //         type: 'select',
    //         label: 'Location Type',
    //         placeholder: 'Select your Location type',
    //         options: [
    //             { value: 1, show: 'Surplus Services Location' },
    //             { value: 2, show: 'Agency Locations' },
    //         ],
    //     },
    //     {
    //         id: 17,
    //         isRequired: true,
    //         colId: 15,
    //         name: 'category',
    //         type: 'select',
    //         label: 'Category',
    //         placeholder: 'Select Category',
    //         options: alldata_all_dropdown
    //             .filter(
    //                 (value) =>
    //                     value.variable === 'category' && value.level === 0
    //             )
    //             .map((item) => {
    //                 let valueChanged = {}
    //                 valueChanged.show = item.description
    //                 valueChanged.value = item.id
    //                 return valueChanged
    //             }),
    //     },
    // ]
    useEffect(() => {
        if (project_dynamicfields && project_dynamicfields.length) {
            // let dynamicValueAssign = {}
            // let searchData = project_dynamicfields
            // dynamicValueAssign.data = searchData
            //     .filter((item) => item.table_search === 1)
            //     .map((buscat) => {
            //         return Object.assign(buscat, {
            //             name: buscat.field,
            //         })
            //     })
            // setSearchInfo(dynamicValueAssign)
            let dynamicAssign = project_dynamicfields.filter(
                (data) =>
                    data.type != 'default' &&
                    data.name !== 'asin' &&
                    data.name !== 'home_depot' &&
                    data.name !== 'upc_id' &&
                    data.active === 1
            )
            let { tempMapData, show, calculateValues } = initialFunction(
                dynamicAssign,
                alldata_all_dropdown,
                subLevelOptions,
                allCountries,
                subStateOptions,
                subCityOptions,
                allLocations
            )
            tempMapData = tempMapData.map((obj) => {
                let matchingObj = dynamicAssign.find(
                    (obj1) => obj1.name === obj.name
                )
                if (matchingObj) {
                    return {
                        ...obj,
                        isRequired: matchingObj.isRequired ? true : false,
                    }
                }
                return obj
            })

            setMapDataFields(tempMapData)
        }
    }, [project_dynamicfields])

    const addSequentialIdsWithMap = (arrayOfObjects) => {
        return arrayOfObjects.map((obj, index) => ({
            ...obj,
            id: index + 1,
            colId: index + 1,
        }))
    }

    const sortedArray = addSequentialIdsWithMap(mapDataFields)
    console.log('====map========>', sortedArray)

    const formik = useFormik({
        initialValues: {
            id: 0,
            categoryTypeId: '',
            subCategoryTypeId: '',
            uploadFiles: [],
            conditionTypeId: '',
            project: 'MINNBID',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            values.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            values.withTime = true
            values.dataFields = sortedArray
            values.defaultFields = { market_status: 'open' }
            uploadXLSXFile(values)
        },
    })
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        if (responseStatusReport?.status === 'success') {
            console.log('report here download ', responseStatusReport)
            window.open(responseStatusReport?.data?.filePath)
        }
        clearResponseReport()
    }, [responseStatusReport])

    useEffect(() => {
        console.log('report here upload ', bulkUploadStatus)
        if (bulkUploadStatus?.status === 'success') {
            toggleFullScreenPopup(false, 'refresh')
        }
        formik.setValues(formik.initialValues)
        formik.resetForm()
        bulkUploadClear()
    }, [bulkUploadStatus])

    const formSubmit = (data) => {
        formik.values.market_status = data
        formik.submitForm().then(setIsLoading(false)).catch(setIsLoading(false))
    }

    const downLoadSample = () =>
        window.open(`${global.site_url}/samples/templates.csv`)

    const productListing = [
        {
            type: 'uploadDropZone',
            formik: formik,
            name: 'uploadFiles',
            titleText: 'Upload XLSX document *',
            class: 'col-12',
            folder: 'temp',
            multiple: false,
            accept: '.xlsx',
        },
        {
            label: 'Category',
            placeholder: 'Select category',
            type: 'select',
            class: 'col-sm-6 col-12',
            options: allCategory
                .filter(
                    (maincat) => maincat.active === 1 && maincat.level === 0
                )
                .map((maincat) => {
                    let categoryChanged = {}
                    categoryChanged.show = maincat.description
                    categoryChanged.value = maincat.id
                    return categoryChanged
                }),
            defaultOptionValue: 'Select a Category',
            name: 'categoryTypeId',
            formik: formik,
        },
        {
            label: 'Sub-Category',
            placeholder: 'Select sub-category',
            type: 'select',
            class: 'col-sm-6 col-12',
            options: allCategory
                .filter((subcat) =>
                    subcat.active === 1 && formik.values.categoryTypeId.length
                        ? formik.values.categoryTypeId.includes(subcat.level_id)
                        : true && subcat.level === 1
                )
                .map((subcat) => {
                    let subCategoryChanged = {}
                    subCategoryChanged.show = subcat.description
                    subCategoryChanged.value = subcat.id
                    return subCategoryChanged
                }),
            defaultOptionValue: 'Select a Sub Category',
            name: 'subCategoryTypeId',
            formik: formik,
        },
        {
            label: 'Condition',
            placeholder: 'Select condition',
            type: 'select',
            class: 'col-sm-6 col-12',
            options: allCondition
                .filter((value) => value.active === 1)
                .map((location) => {
                    let conditionChanged = {}
                    conditionChanged.show = location.description
                    conditionChanged.value = location.id
                    return conditionChanged
                }),
            defaultOptionValue: 'Select a Condition',
            name: 'conditionTypeId',
            formik: formik,
        },
    ]

    return (
        <FullScreenPopup
            modaltitle={`ADD NEW BULK LISTING`}
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addBulkUpload">
                <div className="fspBody">
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="row">
                            <div className="col-md-5 col-12 mb-4">
                                <h4 className="fspTitle">
                                    Bulk Upload Instructions
                                </h4>
                                <ul>
                                    <li>Download the sample file.</li>
                                    <li>
                                        Don&apos;t edit the header names .
                                        Please give the appropriate values for
                                        each fields.
                                    </li>
                                    <li>
                                        You have to give proper categoryTypeId.
                                        <ol>
                                            If you want to add the additional
                                            categories please mention the IDs of
                                            those in comma separated. Ex : 2,3,4
                                            .
                                        </ol>
                                    </li>
                                    <li>
                                        You have to give proper
                                        subCategoryTypeId.
                                        <ol>
                                            If you want to add the additional
                                            sub categories please mention the
                                            IDs of those in comma separated. Ex
                                            : 2,3,4 .
                                        </ol>
                                    </li>
                                    <li>
                                        You have to give proper conditionTypeId.
                                    </li>
                                    <li>
                                        Below are the fields you can enable and
                                        disable them by giving 0 or 1 , that
                                        means it should have 0 or 1
                                        <ol>auction, buynow.</ol>
                                    </li>
                                    <li>
                                        Below are the fields required.
                                        <ol>
                                            <li>
                                                sprice - must be less than
                                                rprice
                                            </li>
                                            <li>
                                                rprice - must be greater sprice
                                                and less than bprice
                                            </li>
                                            <li>
                                                bprice - must be greater or
                                                equal rprice
                                            </li>
                                        </ol>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-7 col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <h4 className="fspTitle">
                                            Upload XLSX document
                                        </h4>
                                    </div>
                                    {Object.values(mapData(productListing))}
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <h5 className="fspSubTitle">Review</h5>
                                        <table className="table text-left">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">
                                                        Category Type Id:
                                                    </th>
                                                    <td className="text-right">
                                                        {formik.values
                                                            .categoryTypeId
                                                            ? formik.values
                                                                  .categoryTypeId
                                                            : 'N/A'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">
                                                        Sub-category Type Id:
                                                    </th>
                                                    <td className="text-right">
                                                        {formik.values
                                                            .subCategoryTypeId
                                                            ? formik.values
                                                                  .subCategoryTypeId
                                                            : 'N/A'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">
                                                        Condition Type Id:
                                                    </th>
                                                    <td className="text-right">
                                                        {formik.values
                                                            .conditionTypeId
                                                            ? formik.values
                                                                  .conditionTypeId
                                                            : 'N/A'}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        id="bulk_download"
                                        type="button"
                                        onClick={() => {
                                            getXLSXFile({
                                                fileName: 'bulk_templates',
                                                sheetName:
                                                    'Template Bulk Upload',
                                                data: sortedArray,
                                            })
                                        }}
                                        label="Download Sample"
                                    />
                                    <PrimaryButton
                                        id="listing_bulk_submit"
                                        onClick={() => {
                                            formSubmit('draft')
                                        }}
                                        type="button"
                                        label="Submit"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default BulkListing
